<template>
    <div
        :class="[
            'page-banner',
            classObject
        ]"
        ref="banner"
    >
        <div class="page-banner__header">
            <div class="page-banner__banner" :style="styleObject">
                <video
                    v-if="bgVideo"
                    class="page-banner__video"
                    ref="video"
                    loop
                    muted
                    playsinline
                    autoplay
                >
                    <source v-if="videoData.mp4" :src="videoData.mp4" type="video/mp4">
                    <source v-if="videoData.webm" :src="videoData.webm" type="video/webm">
                    <source v-if="videoData.ogv" :src="videoData.ogv" type="video/ogg">
                </video>
            </div>
            <div class="container">
                <h1 class="page-banner__title">
                    <slot name="title"></slot>
                </h1>

                <div class="page-banner__text" v-if="this.$slots.text && contentInner">
                    <slot name="text"></slot>
                </div>
            </div>
        </div>

        <div class="page-banner__info" v-if="this.$slots.text && !contentInner">
            <div class="container">
                <div class="page-banner__text">
                    <slot name="text"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { polyfillObjectFitVideo } from '@/utils/util.js'

export default {
    name: 'page-banner',
    props: {
        animate: {
            type: Boolean,
            default: true
        },
        overlay: {
            type: Boolean,
            default: true
        },
        small: {
            type: Boolean,
            default: false
        },
        main: {
            type: Boolean,
            default: false
        },
        contentInner: {
            type: Boolean,
            default: false
        },
        bgImage: {
            type: String,
            default: ''
        },
        bgColor: {
            type: String,
            default: ''
        },
        theme: {
            type: String,
            validator: prop => ['blue'].includes(prop)
        },
        bgVideo: Object
    },
    data() {
        return {
            isAnimate: false,
            device: 'desktop'
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.animate) {
                this.initAnimate();
            }

            polyfillObjectFitVideo('.page-banner__video')
        })

        $('.js-scroll-link--mobile').on('click touchstart', function (e) {
            e.preventDefault()
            let target = $(this).attr('href'),
                $targetSection = $(`.js-scroll-section[data-section-id="${target}"]`),
                offsettop = -40;

            if ($targetSection.data('offsettop') != undefined) {
                offsettop = $targetSection.data('offsettop')
            }

            $targetSection.velocity('scroll', {
                duration: 400,
                offset: offsettop,
                easing: 'ease-in-out'
            })
        })
    },
    computed: {
        videoData () {
            if (!this.bgVideo) return
            if (this.device === 'desktop') return this.bgVideo.desktop
            return this.bgVideo.mobile
        },
        styleObject: function () {
            const styles = {}

            if (this.bgImage) {
                styles.backgroundImage = `url(${this.bgImage})`
            }
            if (this.bgColor) {
                styles.backgroundColor = this.bgColor
            }

            return styles
        },
        classObject () {
            let arrClass = [
                {
                    'page-banner--js-animate' : this.animate,
                    'page-banner--without-overlay' : !this.overlay,
                    'page-banner--is-animate' : this.isAnimate,
                    'page-banner--small' : this.small,
                    'page-banner--main' : this.main,
                }
            ]

            if (this.theme) {
                arrClass.push(`page-banner--theme-${this.theme}`)
            }

            return arrClass
        }
    },
    methods: {
        initAnimate () {
            const $banner = $(this.$refs.banner);
            const _this = this;
            $banner.imagesLoaded({}, function () {
                setTimeout(function () {
                    _this.isAnimate = true
                }, 200);
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// frontend/components/page-banner/page-banner.vue